import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/a11y';
import { A11y, Autoplay, Pagination } from 'swiper/modules';

const MODULE = document.querySelectorAll('[data-module="depoimentos_section"]');

class DepoimentosSection {
    constructor() {
        this.components = MODULE;
        this.init();
    }

    init() {
        this.components.forEach((component) => {
            const swiperEl = component.querySelector('[data-specialists-slider]');
            if (swiperEl) {
                this.initSwiper(component, swiperEl);
            }
        });
    }

    initSwiper(component, swiperEl) {
        if (swiperEl.swiper) {
            return;
        }

        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;

        const swiper = new Swiper(swiperEl, {
            modules: [A11y, Autoplay, Pagination],
            slidesPerView: 'auto',
            spaceBetween: 24,
            watchOverflow: true,
            watchSlidesProgress: true,
            slidesPerGroup: 1,
            autoplay: slideCount > 1 && !reducedMotion
                ? {
                    delay: 10000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                }
                : false,
            speed: reducedMotion ? 0 : 300,
            pagination: {
                el: component.querySelector('.swiper-pagination'),
                clickable: true,
                type: 'bullets',
            },
            a11y: {
                paginationBulletMessage: 'Ir para a posição {{index}}',
                slideLabelMessage: '{{index}} de {{slidesLength}}',
            },
        });

        component.addEventListener('focusin', () => {
            swiper.autoplay.stop();
        });

        if (document.fonts) {
            document.fonts.ready.then(() => swiper.update());
        }

        component.querySelectorAll('img').forEach((image) => {
            image.addEventListener('load', () => swiper.update());
        });
    }
}

(() => {
    if (MODULE.length) {
        new DepoimentosSection();
    }
})();

export default DepoimentosSection;
